/* globals SurveyAnalytics */

import React, { useEffect } from 'react';
import { Model } from 'survey-core';
import PropTypes from 'prop-types';

export default function SurveyJSAnalytics({ surveyJson, surveyResults, options }) {
  const survey = new Model(surveyJson);
  let vizPanelOptions = {
    allowHideQuestions: false,
  };

  if (options) {
    vizPanelOptions = {
      ...vizPanelOptions,
      ...options,
    };
  }

  // Force the analytcs to be text in table instead of WordCloud
  SurveyAnalytics.VisualizationManager.unregisterVisualizerForAll(SurveyAnalytics.WordCloud);

  const vizPanel = new SurveyAnalytics.VisualizationPanel(
    survey.getAllQuestions(),
    surveyResults,
    vizPanelOptions,
  );

  useEffect(() => {
    vizPanel.render('surveyVizPanel');
  }, [surveyResults]);

  return <div id="surveyVizPanel" />;
}

SurveyJSAnalytics.propTypes = {
  surveyJson: PropTypes.shape({}).isRequired,
  surveyResults: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  options: PropTypes.shape({}),
};

SurveyJSAnalytics.defaultProps = {
  options: null,
};
